module.exports = __webpack_public_path__ + "fonts/gothambold-webfont.d152d18c.woff";